import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  disclaimer: {
    marginBottom: 10,
    marginHorizontal: 20,
  },
});
